import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router'
import {
    Box,
    Button,
    Loader,
    Modal,
    Table,
    Text,
    TextField,
} from "../../components";
import { Col, Row } from 'antd';
import { BsArrowLeftShort } from 'react-icons/bs';
import { Colors, Fonts, Images, Utils } from '../../config';
import { useDispatch, useSelector } from 'react-redux';
import { ServiceAction } from '../../store/actions';
import { AiFillPlusCircle } from 'react-icons/ai';
import { FaMinus } from 'react-icons/fa';
import './style.css'


const SubServicesDetail = () => {
    const state = useLocation()?.state;
    const secondLayerRecord = state?.record;
    const mainRecord = state?.previousState;

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { isLoading } = useSelector(state => state?.service)
    const [service, setService] = useState({
        serviceName: "",
        subServices: [{}],
    });

    const [isSubServicesDirty, setIsSubServicesDirty] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const [editService, setEditService] = useState(false);
    const [selectedService, setSelectedService] = useState({});
    const [selectedSubServices, setSelectedSubServices] = useState([]);
    const [singleServiceModal, setSingleServiceModal] = useState(false);
    const [deleteSubServiceIndex, setDeleteService] = useState("");
    const [lengthOfThirdLayerServices, setLengthOfThirdLayerServices] = useState(1);
    const [thirdLayerDeleteServiceIndex, setThirdLayerDeleteServiceIndex] = useState("")
    const [error, setError] = useState({
        id: "",
        name: "",
        subService: { name: "", index: 0 },
        image: "",
    });


    // for managing third layer mutations task
    const [thirdLayerService, setThirdLayerService] = useState({
        subServices: [{
            id: null,
            name: ""
        }],
    })

    useEffect(() => {
        if (state) {
            dispatch(
                ServiceAction.getAllSubServices(secondLayerRecord?.id, (res) => {
                    setService({
                        serviceName: secondLayerRecord?.name,
                        subServices: res.data.subServices?.length > 0 ? res.data.subServices?.map((subService, index) => {
                            return {
                                ...subService,
                                new: false,
                            };
                        }) : []
                    });
                    setIsSubServicesDirty(false);
                    setLengthOfThirdLayerServices(res.data.subServices?.length)
                })
            );
        }
    }, []);


    useEffect(() => {
        if (isSubServicesDirty) {
            dispatch(
                ServiceAction.getAllSubServices(secondLayerRecord?.id, (res) => {
                    setService({ ...service, serviceName: secondLayerRecord?.name, subServices: res.data.subServices });
                    setLengthOfThirdLayerServices(res.data.subServices?.length)
                    setIsSubServicesDirty(false);
                })
            );
        }
    }, [isSubServicesDirty]);

    // const handleCreateService = () => {
    //     if (service.serviceName === "") {
    //         setError({ ...error, name: "Service name is required" });
    //     }
    //     else {
    //         let err = [...error.subService];
    //         var bool = false;
    //         selectedSubServices.forEach((subService, index) => {
    //             if (subService.name.trim() !== "") {
    //                 err[index] = "";
    //             } else {
    //                 bool = true;
    //                 err[index] = "Please enter sub service name";
    //             }
    //         });
    //         if (bool == true) {
    //             setError({ ...error, name: "", subService: err });
    //             return;
    //         } else {
    //             setError({ ...error, subService: err });
    //             let subServices = [];
    //             selectedSubServices?.forEach((subService, index) => {
    //                 if (!subService?.new) {
    //                     subServices.push({
    //                         id: subService?.id,
    //                         name: subService?.name
    //                     })
    //                 }
    //                 else {
    //                     subServices.push({
    //                         id: null,
    //                         name: subService?.name
    //                     })
    //                 }
    //             });
    //             const myPayload = {
    //                 parentId: secondLayerRecord?.id,
    //                 subServices
    //             }
    //             dispatch(
    //                 ServiceAction.updateSubServices(myPayload, () => {
    //                     setShowModal(false);
    //                     setEditService(false);
    //                     setIsSubServicesDirty(true);
    //                 })
    //             );
    //         }
    //     }
    // };

    // const handleAddMoreSubservices = () => {
    //     let err = [...error.subService];
    //     var bool = false;
    //     selectedSubServices.forEach((subService, index) => {
    //         if (subService.name.trim() !== "") {
    //             err[index] = "";
    //         } else {
    //             bool = true;
    //             err[index] = "Please enter sub service name";
    //         }
    //     });
    //     setError({ ...error, subService: err });
    //     if (!bool) {
    //         setSelectedSubServices([
    //             ...selectedSubServices,
    //             {
    //                 id: service.subServices.length + Math.floor(Math.random() * 1000),
    //                 name: "",
    //                 new: true,
    //                 noOfUsers: null,
    //                 index: null,
    //                 isEdit: true,
    //             },
    //         ]);
    //     }
    // };
            
    // const handleCreateService = () => {
    //     if (service.serviceName === "") {
    //         setError({ ...error, name: "Service name is required" });
    //     }
    //     else {
    //         let err = [...error.subService];
    //         var bool = false;
    //         selectedSubServices.forEach((subService, index) => {
    //             if (subService.name.trim() !== "") {
    //                 err[index] = "";
    //             } else {
    //                 bool = true;
    //                 err[index] = "Please enter sub service name";
    //             }
    //         });
    //         if (bool == true) {
    //             setError({ ...error, name: "", subService: err });
    //             return;
    //         } else {
    //             setError({ ...error, subService: err });
    //             let subServices = [];
    //             selectedSubServices?.forEach((subService, index) => {
    //                 if (!subService?.new) {
    //                     subServices.push({
    //                         id: subService?.id,
    //                         name: subService?.name
    //                     })
    //                 }
    //                 else {
    //                     subServices.push({
    //                         id: null,
    //                         name: subService?.name
    //                     })
    //                 }
    //             });
    //             const myPayload = {
    //                 parentId: secondLayerRecord?.id,
    //                 subServices
    //             }
    //             dispatch(
    //                 ServiceAction.updateSubServices(myPayload, () => {
    //                     setShowModal(false);
    //                     setEditService(false);
    //                     setIsSubServicesDirty(true);
    //                 })
    //             );
    //         }
    //     }
    // };

    // const handleAddMoreSubservices = () => {
    //     let err = [...error.subService];
    //     var bool = false;
    //     selectedSubServices.forEach((subService, index) => {
    //         if (subService.name.trim() !== "") {
    //             err[index] = "";
    //         } else {
    //             bool = true;
    //             err[index] = "Please enter sub service name";
    //         }
    //     });
    //     setError({ ...error, subService: err });
    //     if (!bool) {
    //         setSelectedSubServices([
    //             ...selectedSubServices,
    //             {
    //                 id: service.subServices.length + Math.floor(Math.random() * 1000),
    //                 name: "",
    //                 new: true,
    //                 noOfUsers: null,
    //                 index: null,
    //                 isEdit: true,
    //             },
    //         ]);
    //     }
    // };


    const handleAddMoreSubservices = () => {
        let updatedSubServices = [...thirdLayerService.subServices];
        updatedSubServices.push({ id: null, name: "" })
        setThirdLayerService((prev) => ({ ...prev, subServices: updatedSubServices }))
    };

    // third layer remove item handler
    const thirdRemoveHandler = (index) => {
        let updatedSubServices = [...thirdLayerService.subServices];
        updatedSubServices.splice(index, 1)
        setThirdLayerService((prev) => ({ ...prev, subServices: updatedSubServices }))
    }

    // creation and updation of third layer service
    const handleAddSubservice = () => {
        let thirdLayerClone = [...thirdLayerService?.subServices];
        if (thirdLayerClone?.length == 0) {
            Utils.showSnackBar({
                message: "value must contain atleast one item",
                severity: "error"
            })
            return
        }
        let thirdLayerValidationIndex = thirdLayerClone.findIndex(item => item?.name == '')
        if (thirdLayerValidationIndex == 0 || thirdLayerValidationIndex !== -1) {
            setError({
                ...error,
                subService: { index: thirdLayerValidationIndex, name: "Secondary Service is required" }
            })
        }
        else {
            const myPayload = {
                parentId: secondLayerRecord?.id,
                subServices: thirdLayerService?.subServices
            }
            dispatch(
                ServiceAction.updateSubServices(myPayload, () => {
                    setShowModal(false);
                    setEditService(false);
                    setThirdLayerService({
                        subServices: [
                            {
                                id: null,
                                name: ""
                            }
                        ]
                    })
                    setError({
                        id: "",
                        name: "",
                        subService: { name: "", index: 0 },
                        image: "",
                    })
                    setIsSubServicesDirty(true);
                })
            );
        }


    };

    const handleDeleteSubservice = (id) => {
        if (lengthOfThirdLayerServices == 1) {
            Utils.showSnackBar({
                message: "There must be at least one sub service for a service",
                severity: "error",
            });
        }
        else {
            setSelectedSubServices((prev) =>
                prev.filter((subServ) => subServ.id !== selectedService.id)
            );
            dispatch(
                ServiceAction.deleteService(id, () => {
                    setDeleteModal(false);
                    setSelectedService({});
                    setIsSubServicesDirty(true);
                    setShowModal(false)
                })
            );
        }
    };


    return (
        <>
            <Box>
                <Row justify="space-between">
                    <Col className="row-flex-start">
                        <BsArrowLeftShort
                            onClick={() => navigate("/service-management/details", { state: mainRecord })}
                            className="service-details-back-btn"
                        />
                        <Text.Heading
                            fontSize={24}
                            fontFamily={Fonts["Poppins-SemiBold"]}
                            color={Colors.Black}
                            fontWeight={600}
                            text={service.serviceName}
                        />
                    </Col>
                    <Col>
                        <Button.Basic
                            onClick={() => {
                                setEditService(false);
                                setShowModal(true);
                                setSelectedSubServices([...service.subServices]);
                            }}
                            text={"Add Secondary Services"}
                            startIcon={<AiFillPlusCircle color="white" />}
                            className="sub-service-add-btn"
                        />
                    </Col>
                </Row>
                <Row justify="space-between" className="mt-20">
                    {isSubServicesDirty || isLoading ? (
                        <Col span={24} className="row-flex-center mt-20">
                            <Loader.Circular />
                        </Col>
                    ) : (
                        <Col span={24}>
                            <Table.AntDesignTable
                                className="service-details-table"
                                columns={[
                                    {
                                        title: "Secondary Service",
                                        dataIndex: "name",
                                        key: "name",
                                        render: (text, record) => {
                                            return <span>{text}</span>;
                                        },
                                    },
                                    {
                                        title: "No Of Secondary Service",
                                        dataIndex: "noOfUsers",
                                        key: "noOfUsers",
                                        render: (text, record) => {
                                            return <span>{text === null ? "-" : text}</span>;
                                        },
                                    },
                                    {
                                        title: "Action",
                                        dataIndex: "subscription",
                                        key: "subscription",
                                        render: (text, record, outerIndex) => (
                                            <span className="flex items-center action-layout">
                                                <img
                                                    src={Images.EditIcon}
                                                    onClick={() => {
                                                        setEditService(true);
                                                        setThirdLayerService(
                                                            (prev) => {
                                                                let updatedSubService = [...thirdLayerService.subServices];
                                                                updatedSubService[0] = { id: record?.id, name: record?.name };
                                                                return {
                                                                    ...prev,
                                                                    subServices: updatedSubService
                                                                }
                                                            }
                                                        )
                                                    }}
                                                />
                                                {
                                                    // service.subServices?.length > 1 &&
                                                    <img
                                                        onClick={() => {
                                                            setSelectedService(record);
                                                            setDeleteModal(true);
                                                        }}
                                                        src={Images.DeleteIcon}
                                                    />
                                                }

                                            </span>
                                        ),
                                    },
                                ]}
                                data={service.subServices}
                                pagination={true}
                                rowKey="key"
                            />
                        </Col>
                    )}
                </Row>
            </Box>

            {/* {showModal && (
                <Modal.AntDesignModal
                    title=""
                    isModalVisible={showModal}
                    centered={true}
                    handleCancel={() => {
                        setService({
                            ...service,
                        });
                        setError({
                            name: "",
                            subService: "",
                            image: "",
                        });
                        setShowModal(false);
                    }}
                >
                    <Row justify="center">
                        <Col>
                            <Text.Heading
                                fontSize={24}
                                fontFamily={Fonts["Poppins-SemiBold"]}
                                color={Colors.Black}
                                fontWeight={600}
                                text={editService ? "Edit Service" : "Add Service"}
                            />
                        </Col>
                    </Row>
                    <Row justify="center" className="mt-20">
                        <Col span={24}>
                            <TextField.CustomInput
                                label="Service Name: "
                                placeholder="Enter Service Name"
                                value={service.serviceName}
                                size="large"
                                type="text"
                                disabled={true}
                                className="user-subject-field"
                            // onChange={(e) =>
                            //     setService({ ...service, serviceName: e.target.value })
                            // }
                            />
                            <Text.Heading
                                fontSize={14}
                                fontFamily={Fonts["Poppins-Regular"]}
                                color={"red"}
                                fontWeight={400}
                                text={error.name}
                                textAlign="center"
                                className="mt-10"
                            />
                        </Col>
                    </Row>

                    {selectedSubServices.map((subService, index) => {
                        return (
                            <Row key={index} justify="center" className="mt-20 mb-10">
                                <Col span={24}>
                                    <TextField.CustomInput
                                        label={
                                            index === 0
                                                ? `Sub Service Name`
                                                : `Sub Service Name ${index + 1}`
                                        }
                                        placeholder="Enter Sub Service Name"
                                        value={subService.name}
                                        disabled={subService?.isEdit ? false : true}
                                        size="large"
                                        type="text"
                                        className="service-input"
                                        suffix={
                                            (subService?.isEdit && !subService?.new ? false : true) &&
                                            selectedSubServices.length > 1 && (
                                                <img
                                                    className="cursor"
                                                    onClick={() => {
                                                        if (subService?.new) {
                                                            // setSelectedSubServices((prev) =>
                                                            //     prev.filter(
                                                            //         (subServ) => subServ.id !== subService.id
                                                            //     )
                                                            // );
                                                            setThirdLayerDeleteServiceIndex(index)
                                                            setSelectedService({})
                                                            setDeleteModal(true);
                                                        } else {
                                                            const deletedSubservice =
                                                                selectedSubServices.find(
                                                                    (sub) => sub.id === subService.id
                                                                );
                                                            setThirdLayerDeleteServiceIndex('')
                                                            setSelectedService(deletedSubservice);
                                                            setDeleteModal(true);
                                                        }
                                                    }}
                                                    src={Images.DeleteSubServiceIcon}
                                                    width={20}
                                                />
                                            )
                                        }
                                        onChange={(e) => {
                                            let selectedSubServicesCopy = JSON.parse(
                                                JSON.stringify(selectedSubServices)
                                            );
                                            let newService = {
                                                ...selectedSubServices[index],
                                                name: e.target.value,
                                            };
                                            selectedSubServicesCopy[index] = newService;
                                            setSelectedSubServices([...selectedSubServicesCopy]);
                                        }}
                                    />
                                    <Text.Heading
                                        fontSize={14}
                                        fontFamily={Fonts["Poppins-Regular"]}
                                        color={"red"}
                                        fontWeight={400}
                                        text={error.subService[index]}
                                        textAlign="center"
                                        className="mb-10"
                                    />
                                </Col>
                            </Row>
                        );
                    })}

                    {selectedSubServices.length < 20 && editService === false && (
                        <Col className="row-flex-end">
                            <Button.Basic
                                startIcon={<img src={Images.AddSquareIcon} alt="" />}
                                text={"Add More"}
                                className="sub-service-add-btn-modal"
                                onClick={handleAddMoreSubservices}
                            />
                        </Col>
                    )}
                    <Row justify="center">
                        <Col span={24}>
                            <Button.Basic
                                onClick={handleCreateService}
                                text={"Submit"}
                                className="service-provider-email-btn"
                            />
                        </Col>
                    </Row>
                </Modal.AntDesignModal>
            )} */}


            {/* third layer updated working */}
            {showModal && (
                <Modal.AntDesignModal
                    title=""
                    isModalVisible={showModal}
                    destroyOnClose={true}
                    maskClosable={false}
                    handleCancel={() => {
                        setEditService(false);
                        setError({
                            id: "",
                            name: "",
                            subService: { name: "", index: 0 },
                            image: "",
                        })
                        setThirdLayerService((prev) => ({
                            ...prev, subServices: [{ id: null, name: '' }]
                        }))
                        setShowModal(false);
                    }}
                >
                    <Row justify="center">
                        <Col>
                            <Text.Heading
                                fontSize={24}
                                fontFamily={Fonts["Poppins-SemiBold"]}
                                color={Colors.Black}
                                fontWeight={600}
                                text={"Add Secondary Service"}
                            />
                        </Col>
                    </Row>
                    <Row justify="end" className="mt-20" gutter={[16, 18]}>
                        <Col span={24}>
                            <TextField.CustomInput
                                label="Service Name: "
                                placeholder="Engine Checkup"
                                value={mainRecord.name}
                                disabled={true}
                                size="large"
                                type="text"
                                className="service-input"
                            // onChange={(e) =>
                            //     setService({ ...service, serviceName: e.target.value })
                            // }
                            />
                        </Col>
                        <Col span={20}>
                            <TextField.CustomInput
                                label="Sub Service Name: "
                                placeholder="Engine Checkup"
                                value={secondLayerRecord?.name}
                                disabled={true}
                                size="large"
                                type="text"
                                className="service-input"
                            // onChange={(e) =>
                            //     setService({ ...service, serviceName: e.target.value })
                            // }
                            />
                        </Col>
                    </Row>

                    {
                        thirdLayerService?.subServices?.length > 0 &&
                        <Row justify="end" className="mt-20">
                            {
                                thirdLayerService?.subServices?.map((service, index) => (
                                    <Col span={18} key={index}>
                                        <TextField.CustomInput
                                            label={<span>{`Secondary Service Name: `}</span>}
                                            placeholder="Secondary Service Name"
                                            value={service?.name}
                                            size="large"
                                            type="text"
                                            className="user-subject-field"
                                            name={service.name}
                                            onChange={(e) => {
                                                const updatedSubServices = [...thirdLayerService?.subServices];
                                                updatedSubServices[index].name = e?.target?.value;
                                                setThirdLayerService((prev) => ({
                                                    ...prev,
                                                    subServices: updatedSubServices
                                                }))
                                            }}
                                        />
                                        {/*  for error */}
                                        <Text.Heading
                                            fontSize={14}
                                            fontFamily={Fonts["Poppins-Regular"]}
                                            color={"red"}
                                            fontWeight={400}
                                            text={index == error.subService?.index && error?.subService?.name}
                                            textAlign="end"
                                            className="mt-10"
                                        />
                                        <span onClick={() => thirdRemoveHandler(index)} className='minus-icon'><FaMinus size={23} /></span>
                                    </Col>
                                ))
                            }
                        </Row>
                    }

                    <Col className="row-flex-end">
                        <Button.Basic
                            startIcon={<img src={Images.AddSquareIcon} alt="" />}
                            text={"Add More"}
                            className="sub-service-add-btn-modal"
                            onClick={handleAddMoreSubservices}
                        />
                    </Col>

                    <Row justify="center">
                        <Col span={24}>
                            <Button.Basic
                                text={"Submit"}
                                onClick={handleAddSubservice}
                                className="sub-service-add-btn mt-20"
                            />
                        </Col>
                    </Row>
                </Modal.AntDesignModal>
            )}
            {editService && (
                <Modal.AntDesignModal
                    title=""
                    isModalVisible={editService}
                    centered={true}
                    destroyOnClose={true}
                    maskClosable={false}
                    handleCancel={() => {
                        setError({
                            id: "",
                            name: "",
                            subService: { name: "", index: 0 },
                            image: "",
                        });
                        setThirdLayerService((prev) => ({
                            ...prev, subServices: [{ id: null, name: '' }]
                        }))
                        setEditService(false);
                    }}
                >
                    <Row justify="center">
                        <Col>
                            <Text.Heading
                                fontSize={24}
                                fontFamily={Fonts["Poppins-SemiBold"]}
                                color={Colors.Black}
                                fontWeight={600}
                                text={"Edit Secondary Service"}
                            />
                        </Col>
                    </Row>
                    <Row justify="end" className="mt-20">
                        <Col span={24}>
                            <TextField.CustomInput
                                label={<span>{`Secondary Service Name: `}</span>}
                                placeholder="Enter Secondary Service Name"
                                value={thirdLayerService?.subServices[0]?.name}
                                size="large"
                                type="text"
                                className="user-subject-field"
                                onChange={(e) => {
                                    let updatedThirdLayerService = thirdLayerService?.subServices[0];
                                    updatedThirdLayerService.name = e?.target?.value
                                    setThirdLayerService((prev) => ({ ...prev, subServices: [updatedThirdLayerService] }))
                                }}
                            />
                            {/*  for error */}
                            <Text.Heading
                                fontSize={14}
                                fontFamily={Fonts["Poppins-Regular"]}
                                color={"red"}
                                fontWeight={400}
                                text={error.subService?.name}
                                textAlign="end"
                                className="mt-10"
                            />
                        </Col>
                    </Row>
                    <Row justify="center">
                        <Col span={24}>
                            <Button.Basic
                                onClick={handleAddSubservice}
                                text={"Save Changes"}
                                className="service-provider-email-btn"
                            />
                        </Col>
                    </Row>
                </Modal.AntDesignModal>
            )}

            {deleteModal && (
                <Modal.ConfirmationModal
                    title={""}
                    isModalVisible={deleteModal}
                    heading={"Are you sure you want to delete secondary service?"}
                    handleCancel={() => setDeleteModal(false)}
                    handleDelete={() => {
                        if (thirdLayerDeleteServiceIndex) {
                            const deleteSubService = [...selectedSubServices];
                            deleteSubService.splice(thirdLayerDeleteServiceIndex, 1);
                            setSelectedSubServices(deleteSubService)
                            setDeleteModal(false)
                        } else {
                            handleDeleteSubservice(selectedService.id);
                        }
                    }}
                ></Modal.ConfirmationModal>
            )}
        </>
    )
}

export default SubServicesDetail